module.exports = {
  API_URL: 'https://backend.com/api'
}